import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import {
  APPROVE_EMPLOYEE,
  GET_ADDEMPLOYEE,
  GET_EMPLOYEEDETAILS,
  GET_EMPLOYEESLIST,
  GET_UPDATEEMPLOYEE,
  UPLOAD_EMPLOYEE_EXCEL,
} from "resources/actionTypes";
import { getEmployeesList } from "redux/actions/EmployeesAction";
import {
  addEmployeeService,
  getEmployeeDetailsService,
  getEmployeeListService,
  updateEmployeeService,
  uploadEmployeeExcelService,
  approveEmployeeService,
} from "services/EmployeesService";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { API_ENDPOINT } from "services/Api";

function* fetchGetEmployeesList(action) {
  const payload = action.payload || {};
  const employeesList = yield call(getEmployeeListService, payload);
  if (employeesList.success) {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS,
      employeesList: employeesList,
    });
  } else {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED,
      message: employeesList.message,
    });
    toast.error(employeesList.message || "Fetching Employee Failed");
  }
}

export function* getEmployeesListWatcher() {
  yield takeEvery(
    GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
    fetchGetEmployeesList,
  );
}

function* fetchEmployeeDetails(action) {
  const payload = action.payload || {};
  const employeesDetails = yield call(getEmployeeDetailsService, payload);
  if (employeesDetails.success) {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_SUCCESS,
      employeesDetails: employeesDetails,
    });
  } else {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_FAILED,
      message: employeesDetails.message,
    });
    toast.error(employeesDetails.message || "fetching Employee Details Failed");
  }
}

export function* getEmployeeDetailsWatcher() {
  yield takeEvery(
    GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED,
    fetchEmployeeDetails,
  );
}

function* fetchAddEmployee(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const frontdeskAddEmployee = yield call(
    addEmployeeService,
    payload.employeeData,
  );
  if (frontdeskAddEmployee?.success) {
    yield put({ type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_SUCCESS });
    toast.success(frontdeskAddEmployee.message);
    store.dispatch(onLoaderTrigger(false));
    payload.navigate("/front-desk/employeeProfiles", {
      state: { tab: "employeeProfiles" },
    });
  } else {
    yield put({
      type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_FAILED,
      message: frontdeskAddEmployee.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(frontdeskAddEmployee.message || "Add Employee Failed");
  }
}

export function* addEmployeeSaga() {
  yield takeEvery(GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED, fetchAddEmployee);
}

function* fetchUpdateEmployee(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const frontdeskUpdateEmployee = yield call(
    updateEmployeeService,
    payload.employeeData,
    payload.employeeId,
  );
  if (frontdeskUpdateEmployee?.success) {
    yield put({ type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_SUCCESS });
    toast.success(frontdeskUpdateEmployee.message);
    store.dispatch(onLoaderTrigger(false));
    payload.navigate("/front-desk/employeeProfiles", {
      state: { tab: "employeeProfiles" },
    });
  } else {
    yield put({
      type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_FAILED,
      message: frontdeskUpdateEmployee.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(frontdeskUpdateEmployee.message || "Updating Employee Failed");
  }
}

export function* updateEmployeeSaga() {
  yield takeEvery(
    GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED,
    fetchUpdateEmployee,
  );
}

function* fetchUploadEmployeeExcel(action) {
  store.dispatch(onLoaderTrigger(true));

  try {
    const payload = action.payload || {};

    const response = yield call(uploadEmployeeExcelService, payload);

    if (response?.success) {
      yield put({
        type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_SUCCESS,
        data: response,
      });

      yield put(
        getEmployeesList({
          companyId: payload.companyId,
          search: "",
          page: 0,
          pageSize: 10,
          status: "",
        }),
      );

      if (response?.data?.failed > 0) {
        toast.warning(
          `${response?.data?.created || 0} employees added, ${response?.data?.failed} failed`,
        );
      } else {
        toast.success(response.message || "Employees uploaded successfully");
      }
    } else {
      yield put({
        type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_FAILED,
        message: response?.message,
      });

      toast.error(response?.message || "Excel Upload Failed");
    }
  } catch (error) {
    yield put({
      type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_FAILED,
      message: error?.message,
    });

    toast.error("Excel Upload Failed");
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* uploadEmployeeExcelSaga() {
  yield takeEvery(
    UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_REQUESTED,
    fetchUploadEmployeeExcel,
  );
}

function* fetchApproveEmployee(action) {
  store.dispatch(onLoaderTrigger(true));

  try {
    const payload = action.payload;

    const response = yield call(approveEmployeeService, {
      companyId: payload.companyId,
      employeeId: payload.employeeId,
      status: payload.status,
    });

    if (response?.success) {
      yield put({
        type: APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_SUCCESS,
      });

      toast.success(response.message);

      yield put(
        getEmployeesList({
          companyId: payload.companyId,
          search: payload.search,
          page: payload.page,
          pageSize: payload.pageSize,
          status: "",
        }),
      );
    } else {
      yield put({
        type: APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_FAILED,
      });

      toast.error(response.message);
    }
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* approveEmployeeSaga() {
  yield takeEvery(
    APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_REQUESTED,
    fetchApproveEmployee,
  );
}
